import { Link } from '@cfm-media/pwa-ui-components';

export function Document({ blankCode, version, date, iconClass, link, type }) {
  const isInvoice = type === 'invoice';
  const title = isInvoice ? 'Rechnung' : 'Reisedokumente';

  return (
    <Link
      className="cursor-pointer"
      href={link}
      {...(title === 'Rechnung'
        ? { download: link.split('documents/')[1] }
        : {})}
    >
      <div className="bg-white relative mb-3 group rounded-lg shadow">
        <div className="py-3 px-12 text-medium text-brand-1 font-semibold">
          <span
            className={`icon ${iconClass} text-2xl absolute top-1/2 left-3 -translate-y-1/2`}
          ></span>
          {`${title} - Vorgang ${blankCode}`}
          {version ? (
            <span className="text-xs text-gray-500 font-normal block">
              {`Version ${version}`}
            </span>
          ) : null}
          {date ? (
            <span className="text-xs text-gray-500 font-normal block">
              Erstellt am{' '}
              {date.toLocaleDateString('de-DE', { dateStyle: 'medium' })}
            </span>
          ) : null}
          <span className="icon icon-arrow-right-long text-lg absolute top-1/2 right-4 -translate-y-1/2 duration-200 ease-linear group-hover:right-3"></span>{' '}
        </div>
      </div>
    </Link>
  );
}
